<div
  class="tag-button"
  [ngClass]="'tag-button--' + type"
  [matTooltip]="tooltip"
  (click)="onButtonClicked($event)"
>
  @if (iconPlacement === 'left') {
    @if (svgIcon) {
      <mat-icon [svgIcon]="svgIcon"></mat-icon>
    } @else {
      <mat-icon>{{ matIcon }}</mat-icon>
    }
  }

  <ng-content></ng-content>

  @if (iconPlacement === 'right') {
    @if (svgIcon) {
      <mat-icon [svgIcon]="svgIcon"></mat-icon>
    } @else {
      <mat-icon>{{ matIcon }}</mat-icon>
    }
  }
</div>
